import { render, staticRenderFns } from "./SMSProfile.vue?vue&type=template&id=57b95c2e&scoped=true"
import script from "./SMSProfile.vue?vue&type=script&lang=js"
export * from "./SMSProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b95c2e",
  null
  
)

export default component.exports